import * as actionTypes from './actionTypes';

interface State {
  nameModal: string;
  open: boolean;
}

const initialState = {
  nameModal: 'NO_MODAL',
  open: false
};

export const modals = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.OPEN_MODAL:
      return {
        ...state,
        nameModal: action.nameModal,
        open: true
      };
    case actionTypes.CLOSE_MODAL:
      return initialState;
    default:
      return state;
  }
};
